import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

export const ProductSearchResultItemSellerSponsoredLabel: FC = () => (
  <ProductSearchResultItemGenericLabel className="border-dark-primary-min bg-light-primary-low">
    <FormattedMessage id="general.label.sponsored" />
  </ProductSearchResultItemGenericLabel>
)
